/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 14:33:27
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-27 12:41:43
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/TimeAndDatePickField/TimeAndDatePickerWithAlwaysOn/index.tsx
 */
import React from 'react';
import { Radio } from 'src/components/Antd';
import TimeAndDatePicker from '../TimeAndDatePicker';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import css from './css.module.less';
import moment from 'moment';
import ErrNotice from 'src/components/ErrorNotice/Err';

const ALWAYS_ON = 'alwaysOn';
const CustomizedPeriod = 'customizedPeriod';

const formatDateFromServer = (date, time) => {
  if (!(date && time)) {
    return null;
  } else {
    return `${date} ${time}`;
  }
};

const deconstructionDate = (_startTime, _endTime) => {
  const start = _startTime ? moment(_startTime) : null;
  const end = _endTime ? moment(_endTime) : null;
  const beginDate = start ? start.format('YYYY-MM-DD') : null;
  const beginTime = start ? start.format('HH:mm') : null;
  const endDate = end ? end.format('YYYY-MM-DD') : null;
  const endTime = end ? end.format('HH:mm') : null;
  return { beginDate, beginTime, endDate, endTime };
};

const formatMoment = (time) => {
  if (time) {
    return moment(time).format('DD MMM YY HH:mm');
  } else {
    return '-';
  }
};

export {
  formatDateFromServer,
  ALWAYS_ON,
  CustomizedPeriod,
  deconstructionDate,
  formatMoment,
};
const TimeAndDatePickerWithAlwaysOn = (props) => {
  const {
    // disableStartTime,
    error,
    data,
    occupiedRange,
    timezone,
    onTypeChange,
    onDateChange,
    disabled,
  } = props;

  const { alwaysOn, startTime, endTime } = data || {};

  const [type, setType] = React.useState(
    alwaysOn ? ALWAYS_ON : CustomizedPeriod,
  );

  React.useEffect(() => {
    if (alwaysOn && type !== ALWAYS_ON) {
      setType(ALWAYS_ON);
    }
    if (!alwaysOn && type !== CustomizedPeriod) {
      setType(CustomizedPeriod);
    }
  }, [alwaysOn]);

  const handleTypeOnChange = (e) => {
    const _v = e.target.value;
    if (onTypeChange) {
      if (_v === ALWAYS_ON) {
        onTypeChange({ type: _v });
      } else {
        onTypeChange({ type: _v });
      }
    }
  };

  const handleTimeOnChange = (timeObj) => {
    if (onDateChange) {
      onDateChange(timeObj);
    }
  };

  return (
    <ItemWrapper title='Display'>
      <div className={css.radioContainer}>
        <Radio
          radioList={[
            {
              label: 'Always on shopper end',
              value: ALWAYS_ON,
              className: css.radioWrapper,
            },
            {
              label: 'Scheduled Time',
              value: CustomizedPeriod,
            },
          ]}
          onChange={handleTypeOnChange}
          value={type}
          disabled={disabled}
        />
      </div>
      {!alwaysOn && (
        <React.Fragment>
          <div className={css.timeDisplayContainer}>
            <TimeAndDatePicker
              timeZone={timezone ? `Time Zone UTC ${timezone}` : ''}
              occupiedRange={occupiedRange}
              data={{ startTime, endTime }}
              onChange={handleTimeOnChange}
              disabled={disabled}
            />
          </div>{' '}
          {error && <ErrNotice className={css.errContainer}>{error}</ErrNotice>}
        </React.Fragment>
      )}
    </ItemWrapper>
  );
};
export default TimeAndDatePickerWithAlwaysOn;
